export default __webpack_public_path__ + "static/media/usability-bg.5f02b1c5.svg";